/* eslint-disable import-x/no-extraneous-dependencies */
import { useCountUp } from 'react-countup';
import { UseCountUpProps } from 'react-countup/build/useCountUp';
/* eslint-enable import-x/no-extraneous-dependencies */
import React, { useEffect, useRef } from 'react';
import HBText, { ITextProps } from '../HBText/HBText';

type CountupProps = Partial<Pick<UseCountUpProps, 'start' | 'duration'>>;

interface Props
    extends Partial<CountupProps>,
        Pick<UseCountUpProps, 'end'>,
        Omit<Partial<ITextProps>, 'children'> {}

const HBCountUp = ({ start = 0, end, duration = 1, ...textProps }: Props) => {
    const ref = useRef(null);

    const { update } = useCountUp({
        ref,
        start,
        end,
        duration,
        useEasing: true,
        easingFn: easeInOutCubic
    });

    useEffect(() => update(end), [update, end]);

    if (textProps.type) {
        // @ts-ignore
        return <HBText ref={ref} {...textProps} />;
    }
    return <span ref={ref} />;
};

export default HBCountUp;

// If you want a different curve, propify 'easingFn' and add a new easing function from:
// https://github.com/danro/jquery-easing/blob/master/jquery.easing.js

/* eslint-disable no-param-reassign */
const easeInOutCubic = (t: number, b: number, c: number, d: number) => {
    if ((t /= d / 2) < 1) {
        return (c / 2) * t * t * t + b;
    }
    return (c / 2) * ((t -= 2) * t * t + 2) + b;
};
